<div class="account-menu">
    <div class="account-menu__divider"></div>
    <a routerLink="/account/dashboard" class="account-menu__user" (click)="closeMenu.emit()">
        <div class="account-menu__user-info">
            <div class="account-menu__user-name">{{userName}}</div>
                   </div>
    </a>
    <div class="account-menu__divider"></div>
    <ul class="account-menu__links">
        <li><a (click)="Profile()" style="cursor: pointer" ><i class="fa-solid fa-user" style="color: #767b7f;"></i>&nbsp; Profile</a></li>
        <li><a (click)="ChangePassword()" style="cursor: pointer"><i class="fa-solid fa-lock"  style="color: #767b7f;"></i>&nbsp;  Change Password</a>
        <li><a (click)="logout($event)" style="cursor: pointer"><i class="fa-solid fa-right-from-bracket" style="color: #767b7f;"></i>&nbsp; Logout</a></li>
    </ul>
</div>
